export const loadBalance = async (url, extra) => {
    let primary = process.env[url + '_PRIMARY'] + extra
    let secondary = process.env[url + '_SECONDARY'] + extra
    if (await getUrlStatus(primary).then((res) => {
        return res
    }).catch(e => {
        return false
    })) {
        window.open( primary, '_blank', 'noopener,noreferrer');
    } else {
        window.open( secondary, '_blank', 'noopener,noreferrer');
    }
};

export const loadBalanceSamePage = async (url, extra) => {
    let primary = process.env[url + '_PRIMARY'] + extra
    let secondary = process.env[url + '_SECONDARY'] + extra
    if (await getUrlStatus(primary).then((res) => {
        return res
    }).catch(e => {
        return false
    })) {
        window.open( primary, '_self' );
    } else {
        window.open( secondary, '_self' );
    }
};


function getUrlStatus(url) {
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open('HEAD', url);
        xhr.timeout = 3000;
        xhr.onreadystatechange = function (data) {
            if (this.readyState === XMLHttpRequest.DONE) {
                let status = this.status;
                if (status !== 0) {
                    if (status >= 200 && status < 400) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                }
            }
        };
        xhr.onloadend = () => {
            resolve(true)
        };
        xhr.ontimeout = () => {
            resolve(false)
        };
        xhr.error = function (e) {
            resolve(false)
        };
        xhr.send();
    });
}